import React, { useRef, useMemo } from "react";
import "./PageFormRenderer.scss";
import PageFormProgress from "./PageFormProgress/PageFormProgress";
import useFormWizard from "../FormWizardProvider";
import {
  useNavigationProtection,
  PageHeader,
  type NavigationBreadcrumbItem,
} from "@SeemplicityDev/shared";

export type PageFormRendererProps = {
  children: React.ReactNode;
  className?: string;
  breadcrumbs?: NavigationBreadcrumbItem[];
};

const PageFormRenderer: React.FC<PageFormRendererProps> = ({
  children,
  className,
  breadcrumbs,
}) => {
  const { formSteps, activeStepIndex, formOrigin, wizardName } =
    useFormWizard();
  const ref = useRef<HTMLDivElement>(null);

  useNavigationProtection({
    containerRef: ref,
    warningMessage: `You haven't completed all steps. If you leave now, the data will be deleted.\n\nAre you sure you want to exit the wizard and cancel the ${wizardName}?`,
  });

  const derivedBreadcrumbs = useMemo(
    () => [
      ...(formOrigin?.name ? [{ label: formOrigin.name }] : []),
      { label: wizardName },
    ],
    [formOrigin?.name, wizardName]
  );

  return (
    <div className={`page-form-wizard-wrapper ${className}`} ref={ref}>
      <div className={"page-form-wizard-header"}>
        <PageHeader
          breadcrumbs={breadcrumbs ?? derivedBreadcrumbs}
          data-testid="page-form-breadcrumbs"
        />
        <PageFormProgress steps={formSteps} activeStepIndex={activeStepIndex} />
      </div>
      <div className={"page-form-wizard-layout"}>{children}</div>
    </div>
  );
};

export default PageFormRenderer;
